export default __webpack_public_path__ + "media/images/carousel/24-6ba4fd449280987327f86f3fdb370b5d.png";